<template>
  <el-card
    :body-style="cardBody"
    id="order-trajectory"
    class="mead-bike-map"
  >
    <template #header>
      <content-header />
    </template>
    <div class="header-button">
      <search-form
        ref="searchForm"
        :fields="search"
      />
      <div class="selections">
        <el-button
          type="success"
          @click="superSearchDialogVisible=true"
        >
          <slot>高级搜索</slot>
        </el-button>
        <!-- <el-button type="primary" @click="addAdvertisement">添加广告</el-button> -->
      </div>
    </div>
    <el-dialog
      title="高级搜索"
      :visible.sync="superSearchDialogVisible"
      width="30%"
    >
      <el-form
        ref="superForm"
        :model="superForm"
        :rules="superFormRules"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item
          required
          prop="bike_no"
          label="车辆编号"
        >
          <el-input
            v-model="superForm.bike_no"
            style="width:350px;"
          />
        </el-form-item>
        <el-form-item
          required
          prop="time_between"
          label="日期区间"
        >
          <el-date-picker
            v-model="superForm.time_between"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="superSearchDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="superSearch('superForm')"
        >确 定</el-button>
      </span>
    </el-dialog>
    <el-row
      justify="center"
      style="height:calc(100% - 57px); display:flex;"
    >
      <div class="amap-page-container">
        <el-amap
          vid="amap"
          :plugin="plugin"
          class="amap-demo"
          :center="center"
          :default-cursor="defaultCursor"
          :zoom="zoom"
          :amap-manager="amapManager"
          :events="events"
        >
          <!-- <el-amap-polyline
                      :editable="polyline.editable"
                      :path="polyline.path"
                      :outline-color="polyline.outlineColor"
                      :stroke-color="polyline.strokeColor"
                      :events="polyline.events"
                      :line-join="polyline.lineJoin"
                      :stroke-style="polyline.strokeStyle"
                      :stroke-dasharray="polyline.strokeDasharray"
                    /> -->
          <el-amap-marker
            :position="startMark.position"
            :events="startMark.events"
            :visible="startMark.visible"
            :draggable="startMark.draggable"
            :icon="startMark.icon"
          />
          <!-- <div v-for="(item,index) in polyline.path" :key="index">
                      <el-amap-marker
                        :position="item"
                        :events="startMark.events"
                        :visible="startMark.visible"
                        :draggable="startMark.draggable"
                        :icon="startMark.icon1"
                      />
                    </div> -->
          <div
            v-for="(item,index) in pathMarks"
            :key="index"
          >
            <el-amap-marker
              :position="[item[0],item[1]]"
              :events="marker.events"
              :visible="marker.visible"
              :draggable="marker.draggable"
              :vid="index"
            />
          </div>
          <el-amap-marker
            :position="endMark.position"
            :events="endMark.events"
            :visible="endMark.visible"
            :draggable="endMark.draggable"
            :icon="endMark.icon"
          />
        </el-amap>
      </div>
      <div class="infos">
        <el-card
          class="item-row"
          v-show="dataNull"
        >
          <div
            class="item-info"
            style="color: #909399; margin:0 auto;"
          >
            <span>暂无数据 ~~</span>
          </div>
        </el-card>
        <div
          v-for="(row, key) in orders"
          :key="key"
          class="info-list"
        >
          <div
            @click="rowClick(row,key)"
            style="width:100%;"
          >
            <el-card
              class="item-row order-trajectory"
              :class="{'gary':row.isClick==true}"
            >
              <div class="item-info">
                <i class="el-icon-bicycle">车牌号：</i>
                <span>{{ row.bike_no }}</span>
              </div>
              <div class="item-info">
                <i class="el-icon-document">订单号：</i>
                <span>{{ row.no }}</span>
              </div>
              <div class="item-info">
                <i class="el-icon-document">订单状态：</i>
                <span>{{ row.orders_status }}</span>
              </div>
              <div class="item-info">
                <i class="el-icon-phone">手机号：</i>
                <span>{{ row.mobile }}</span>
              </div>
              <div class="item-info">
                <i class="el-icon-alarm-clock">订单开始时间：</i>
                <span>{{ row.start_use_bike_time }}</span>
              </div>
              <div class="item-info">
                <i class="el-icon-alarm-clock">订单结束时间：</i>
                <span>{{ row.end_use_bike_time }}</span>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </el-row>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import { getAdminUsersMerchant } from "@/api/admin-merchant";

import {
  orderRentLocationsearch,
  getOrderRentStatus,
  getOrderRentLocation,
  getOrderRentTrajectory
} from "@/api/order-rent";
import { getAreas } from "@/api/area";
import VueAMap from "vue-amap";
import env from "../../env";
export default {
  name: "Index",
  components: {
    SearchForm
  },
  data() {
    let amapManager = new VueAMap.AMapManager();
    return {
      clickIn: "",
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "status",
          label: "订单状态",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
      
        {
          field: "mobile",
          label: "手机号"
        },
        {
          field: "no",
          label: "订单号"
        },
        {
          field: "bike_no",
          label: "车牌号"
        }
      ],
      superForm: {
        bike_no: "",
        time_between: ""
      },
      superFormRules: {
        bike_no: [
          { required: true, message: "请输入车辆编号", trigger: "blur" }
        ],
        time_between: [
          { required: true, message: "请选择时间区间", trigger: "change" }
        ]
      },
      orders: [],
      page: null,
      cardBody: {
        padding: "20px",
        height: "100%"
      },
      dataNull: false,
      plugin: [
        {
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              // console.log(o)
              o.getCurrentPosition((status, result) => {
                // 未配置https  定位失败 暂时手动配置
                // console.log(self)
                self.lng = 113.73350255780726;
                self.lat = 34.78024666564106;
                self.center = [self.lng, self.lat];
                self.loaded = true;
                if (result && result.position) {
                  self.lng = result.position.lng;
                  self.lat = result.position.lat;
                  self.center = [self.lng, self.lat];
                  self.loaded = true;
                }
              });
            }
          }
        },
        {
          pName: "Scale",
          // offset: { x: 1, y: 1 },
          position: "RB",
          events: {
            init(instance) {
              // console.log(instance)
            }
          }
        },
        {
          pName: "ToolBar",
          events: {
            init(instance) {
              // console.log(instance)
            }
          }
        }
      ],
      defaultCursor: "pointer",
      center: [121.59996, 31.197646],
      zoom: 12,
      amapManager: amapManager,
      pathData: [],
      pathDataTimes: [],
      pathDataRoles: [],
      pathMarks: [],
      events: {
        init(o) {}
      },

      marker: {
        position: [0, 0],
        events: {
          click: () => {
            // alert('click marker')
          },
          dragend: e => {
            // this.markers[0].position = [e.lnglat.lng, e.lnglat.lat]
          }
        },
        visible: true,
        draggable: false
      },
      startMark: {
        position: [0, 0],
        events: {
          click: () => {
            // alert('click marker')
          },
          dragend: e => {}
        },
        visible: true,
        draggable: false,
        template: "<span>1</span>",
        icon:
          "http://resource.bike.hanyiyun.com/common/start-location-mark35px.png",
        icon1: "http://resource.bike.hanyiyun.com/common/markMinRoundPoint.png"
      },
      endMark: {
        position: [0, 0],
        events: {
          click: () => {},
          dragend: e => {}
        },
        visible: true,
        draggable: false,
        template: "<span>1</span>",
        icon:
          "http://resource.bike.hanyiyun.com/common/end-location-mark35px.png"
      },
      superSearchDialogVisible: false
    };
  },
  watch: {
    $route: {
      async handler(newVal) {
        const { data } = await orderRentLocationsearch(newVal.query);
        let arr = data;
        for (var i = 0; i < arr.length; i++) {
          this.$set(arr[i], "isClick", false);
        }
        arr = arr;
        this.orders = arr;
        this.dataNull = false;
        if (this.orders.length == 0) {
          this.dataNull = true;
          this.$message("暂无数据");
        }
      },
      immediate: true
    }
  },
  inject: ["reload"],
  async created() {
   
    const [{ data: areas }, { data: orderStatus }] = await Promise.all([
      getAreas({ all: 1 }),
      getOrderRentStatus()
    ]);
    this.search[0].options.push.apply(this.search[0].options, areas);
    this.search[1].options.push.apply(
      this.search[1].options,
      orderStatus.order_status
    );
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
       if (env.isPosSwitch == true) {
      this.search.push({
        type: "el-select",
        field: "merchant_id",
        label: "商户",
        options: [
          {
            id: "",
            name: "全部"
          }
        ]
      });
      this.search[5].options.push.apply(this.search[5].options, merchant.data);
    }
    }
  },
  methods: {
    async rowClick(row, index) {
      if (this.clickIn === index) {
        return;
      }
      this.clickIn = index;
      let _this = this;
      for (var i = 0; i < this.orders.length; i++) {
        this.orders[i].isClick = false;
      }
      this.orders[index].isClick = true;
      const [{ data }] = await Promise.all([
        getOrderRentLocation({ order_id: row.id })
      ]);
      let OrderLocation = data.orderLocations;
      this.pathDataTimes = data.locationsTimes;
      this.pathDataRoles = data.locations_role;
      if (OrderLocation.length == 0) {
        this.startMark.position = [0, 0];
        this.endMark.position = [0, 0];
        this.pathMarks = [];
        this.$message("此订单暂无轨迹");
        if (window.pathSimplifierIns) {
          pathSimplifierIns.setData([]);
          pathSimplifierIns.clearPathNavigators();
        }
      } else {
        this.startMark.position = OrderLocation[0];
        this.endMark.position = OrderLocation[OrderLocation.length - 1];
        let i = parseInt(OrderLocation.length / 2);
        // console.log(i)
        let centre = OrderLocation[i];
        this.center = centre;
        this.zoom = 15;
        this.pathData = OrderLocation;
        this.pathMarks = [];

        if (window.pathSimplifierIns) {
          // 去除轨迹
          pathSimplifierIns.setData([]);

          // 去除巡航器
          pathSimplifierIns.clearPathNavigators();
        }
        AMapUI.load(["ui/misc/PathSimplifier"], function(PathSimplifier) {
          if (!PathSimplifier.supportCanvas) {
            alert("当前环境不支持 Canvas！");
            return;
          }

          // 启动页面
          _this.initPage(PathSimplifier);
        });
      }

      // console.log(OrderLocation)
    },
    initPage(PathSimplifier) {
      let _this = this;
      // 创建组件实例
      var pathSimplifierIns = new PathSimplifier({
        zIndex: 100,
        map: this.amapManager._map, // 所属的地图实例
        getPath: function(pathData, pathIndex) {
          // 返回轨迹数据中的节点坐标信息，[AMap.LngLat, AMap.LngLat...] 或者 [[lng|number,lat|number],...]
          return pathData.path;
        },
        getHoverTitle: function(pathData, pathIndex, pointIndex) {
          // console.log(_this.pathDataTimes)
          // 返回鼠标悬停时显示的信息
          if (pointIndex >= 0) {
            // 鼠标悬停在某个轨迹节点上
            return (
              pathData.name +
              "，点:" +
              pointIndex +
              "/" +
              pathData.path.length +
              ",时间:" +
              _this.pathDataTimes[pointIndex] +
              ",角色:" +
              _this.pathDataRoles[pointIndex]
            );
          }
          // 鼠标悬停在节点之间的连线上
          return pathData.name + "，点数量" + pathData.path.length;
        },
        renderOptions: {
          // 轨迹线的样式
          pathLineStyle: {
            strokeStyle: "red",
            lineWidth: 2,
            dirArrowStyle: true
          },
          renderAllPointsIfNumberBelow: 100
        }
      });
      pathSimplifierIns.renderLater([{ delay: 1000 }]);
      window.pathSimplifierIns = pathSimplifierIns;

      // 这里构建两条简单的轨迹，仅作示例
      pathSimplifierIns.setData([
        {
          name: "轨迹",
          path: this.pathData
        }
      ]);

      // 创建一个巡航器
      var navg0 = pathSimplifierIns.createPathNavigator(
        0, // 关联第1条轨迹
        {
          loop: true, // 循环播放
          speed: 500
        }
      );

      navg0.start();
    },
    superSearch(form) {
      var _this = this;
      _this.clickIn = "";
      // console.log(this.superForm)
      this.$refs[form].validate(valid => {
        if (valid) {
          // alert('submit!')
          getOrderRentTrajectory(this.superForm).then(res => {
            res.then(data => {
              // console.log(data.data)
              if (window.pathSimplifierIns) {
                // console.log(pathSimplifierIns)
                // 去除轨迹
                pathSimplifierIns.setData([]);
                // pathSimplifierIns.destroy()

                // 去除巡航器
                pathSimplifierIns.clearPathNavigators();
              }

              this.orders = [];
              this.pathMarks = [];
              this.pathData = data.data.locations;
              this.pathDataTimes = data.data.locations_time;
              this.pathDataRoles = data.data.locations_role;
              this.pathMarks = data.data.marks;
              this.superSearchDialogVisible = false;
              this.startMark.position = [0, 0];
              this.endMark.position = [0, 0];
              if (data.data.length === 0) {
                this.startMark.position = [0, 0];
                this.endMark.position = [0, 0];
                this.pathMarks = [];
                this.$message("暂无记录");
                // console.log(111)
                return;
              }
              this.orders = data.data.orders;

              AMapUI.load(["ui/misc/PathSimplifier"], function(PathSimplifier) {
                if (!PathSimplifier.supportCanvas) {
                  alert("当前环境不支持 Canvas！");
                  return;
                }

                // 启动页面
                _this.initPage(PathSimplifier);
              });
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.amap-page-container {
  width: 80%;
  height: 100%;
  // display: inline-block;
  .amap-demo {
    /*height: 95%;*/
    position: relative;
  }
}

.amap-icon {
  img {
    //  width: 35px !important;
  }
}

.infos {
  height: 100%;
  width: 22%;
  cursor: pointer;
  // display: inline-block;
  margin-left: 2px;
  overflow: auto;
}

.info-list {
  width: 100%;
  flex-direction: row-reverse;
  display: flex;
  // background-color: hsla(0, 0%, 100%, 0.9);
  font-size: 14px;
  line-height: 1.15;
  .item-info {
    padding: 2.5px 0;
    span {
      margin: 5px;
    }
  }
}

.gary {
  background-color: #aaa;
}

.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}

#order-trajectory {
  height: 98%;
  .el-card__body {
    height: 94% !important;
    .is-justify-center {
      /*height: 94%!important;*/
      height: calc(100% - 57px);
    }
    .amap-demo {
      height: 100%;
    }
  }
}
</style>
